import { EditOutlined, FileTextOutlined, UploadOutlined } from "@ant-design/icons";
import { Button, Descriptions, Flex, Tag } from "antd";
import dayjs from "dayjs";
import { useState } from "react";
import { Link, useLoaderData, useNavigate, useRouteLoaderData } from "react-router";
import BackTitle from "../common/BackTitle";
import { date2locale } from "../common/common";
import PdfViewer from "../common/PdfViewer";
import PageTitle from "../components/PageTitle";

export default function Course() {
  const course = useRouteLoaderData("course");
  const [openCertificate, setOpenCertificate] = useState(false);
  const navigate = useNavigate();
  const today = dayjs().startOf("day");
  const status = course.dueDate
    ? dayjs(course.dueDate).isBefore(today)
      ? { color: "red", text: "Scaduto" }
      : { color: "green", text: "Valido" }
    : dayjs(course.date).isAfter(today)
      ? { color: "default", text: "Programmato" }
      : { color: "blue", text: "Carica attestato" };
  const formatDate = (date) => (date ? date2locale(date) : "—");

  return (
    <Flex vertical gap={24}>
      <PageTitle title={"Dettaglio corso di formazione"} description={`ID: ${course.id}`} />
      <Descriptions
        layout="vertical"
        title={
          <Link to={"edit"}>
            <Button type="link" icon={<EditOutlined />}>
              Modifica
            </Button>
          </Link>
        }
        colon={false}
        column={{ xs: 1, sm: 2, md: 3 }}
        items={[
          { key: "id", label: "ID", children: course.id },
          { key: "categoria", label: "Categoria", children: course.courseType?.title },
          { key: "employee", label: "Dipendente", children: course.employee?.fullName },
          {
            key: "isBase",
            label: "Tipo corso",
            children: course.isBase ? "Base" : "Aggiornamento",
          },
          { key: "date", label: "Data", children: formatDate(course.date) },
          {
            key: "status",
            label: "Stato",
            children: <Tag color={status.color}>{status.text}</Tag>,
          },
          { key: "instructor", label: "Docente", children: course.instructor || "—" },
          { key: "location", label: "Indirizzo", children: course.location || "—" },
          {
            key: "certificateDate",
            label: "Data attestato",
            children: formatDate(course.certificateDate),
          },
          {
            key: "dueDate",
            label: "Data scadenza attestato",
            children: formatDate(course.dueDate),
          },
          {
            key: "notes",
            label: "Note",
            span: 3,
            children: <span style={{ whiteSpace: "pre-wrap" }}>{course.notes || "—"}</span>,
          },
          {
            key: "certificate",
            label: "Attestato",
            children:
              course.certificateDate == null ? (
                <Button icon={<UploadOutlined />} onClick={() => navigate("certificate")}>
                  Carica attestato
                </Button>
              ) : course.ref ? (
                <Button icon={<FileTextOutlined />} onClick={() => setOpenCertificate(true)}>
                  Visualizza attestato
                </Button>
              ) : (
                "—"
              ),
          },
        ]}
      />
      <PdfViewer
        url={openCertificate ? `/course/${course.id}/file` : null}
        onClose={() => setOpenCertificate(false)}
      />
    </Flex>
  );
}
